/**
 * IMAYO サムネイルスライダー共通JS
 * 商品カード内の画像切り替え機能（PC: ホバーで表示→矢印で切り替え、SP: スワイプスライド）
 */
(function () {
  let isSp = window.matchMedia("(max-width: 767px)").matches;

  const mediaQueryList = window.matchMedia("(max-width: 767px)");
  mediaQueryList.addEventListener("change", (e) => {
    isSp = e.matches;
  });

  function initThumbSliders() {
    const thumbSliders = document.querySelectorAll(".slide-img");

    thumbSliders.forEach((slider) => {
      // 二重初期化防止
      if (slider.classList.contains("is-thumb-initialized")) return;

      const track = slider.querySelector(".js-thumb-track");
      const allImages = slider.querySelectorAll(".js-thumb-track img");
      const prevBtn = slider.querySelector(".js-thumb-prev");
      const nextBtn = slider.querySelector(".js-thumb-next");

      // 要素が不足している場合はスキップ
      if (!track || allImages.length === 0 || !prevBtn || !nextBtn) return;

      // 画像リストのフィルタリング
      // SP: 全画像 (サムネイル含む)
      // PC: .u-sp を除く画像
      let thumbImages = [];
      if (isSp) {
        thumbImages = Array.from(allImages);
      } else {
        thumbImages = Array.from(allImages).filter((img) => !img.classList.contains("u-sp"));
      }

      let currentIndex = 0;

      // 画像の枚数
      const slideCount = thumbImages.length;

      // 現在のインデックスを取得する関数（SPの場合はスクロール位置から計算）
      const getCurrentIndex = () => {
        if (isSp) {
          const scrollLeft = track.scrollLeft;
          const width = track.clientWidth;
          return Math.round(scrollLeft / width);
        }
        return currentIndex;
      };

      // 表示切り替え関数
      const updateSlide = (index) => {
        currentIndex = index;
        if (isSp) {
          // SP: Scroll Snap
          const width = track.clientWidth;
          track.scrollTo({
            left: width * currentIndex,
            behavior: "smooth",
          });
        } else {
          // PC: Transform
          const translateX = -100 * currentIndex;
          track.style.transform = `translateX(${translateX}%)`;
        }
      };

      // 初期化
      if (isSp) {
        // SPの場合、transformをリセットしてスクロール位置も先頭に
        track.style.transform = "";
        track.scrollLeft = 0;

        // SP用の矢印フェード制御
        let scrollTimer;
        const showArrows = () => {
          prevBtn.style.opacity = "1";
          prevBtn.style.visibility = "visible";
          nextBtn.style.opacity = "1";
          nextBtn.style.visibility = "visible";
        };
        const hideArrows = () => {
          prevBtn.style.opacity = "0";
          prevBtn.style.visibility = "hidden";
          nextBtn.style.opacity = "0";
          nextBtn.style.visibility = "hidden";
        };

        // スクロール時の制御
        track.addEventListener("scroll", () => {
          showArrows();
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => {
            hideArrows();
          }, 1000);
        });

        // タッチ操作時の制御
        track.addEventListener("touchstart", () => {
          showArrows();
          clearTimeout(scrollTimer);
        });
        track.addEventListener("touchend", () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => {
            hideArrows();
          }, 1000);
        });
      } else {
        updateSlide(0);
      }

      // 前へボタン
      prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        // 現在位置を基準にする（特にSPのスクロール後を考慮）
        let current = getCurrentIndex();
        let nextIndex = current - 1;

        if (nextIndex < 0) {
          nextIndex = slideCount - 1;
        }
        updateSlide(nextIndex);
      });

      // 次へボタン
      nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        // 現在位置を基準にする
        let current = getCurrentIndex();
        let nextIndex = current + 1;

        if (nextIndex >= slideCount) {
          nextIndex = 0;
        }
        updateSlide(nextIndex);
      });

      slider.classList.add("is-thumb-initialized");
    });
  }

  // グローバル関数としてエクスポート
  window.initImayoThumbSliders = initThumbSliders;

  // 読み込み時に自動初期化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initThumbSliders);
  } else {
    initThumbSliders();
  }
})();
